import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  loginInfoFormSuccess,
  LOGIN_INFO_FORM,
  loginInfoFormError,
  resetLogin,
  LOGOUT
} from "../actions/loginForm";

import { authentication } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import { parseJwt } from "../../utils/genericUtils";
import { getAuthorizationHeader } from "../selectors/appConfig";
import { receiveAppConfig, setAccessToken, setPrevDeviceId } from "../actions/appConfig";
import { DEVICE_ID } from "../../api/axiosConfig";
import { getLoginResponse } from "../selectors/loginSelector";

function* getProspectProcessingData() {
  return {
    agentId: (yield select(getLoginResponse)).agentId,
    headers: yield select(getAuthorizationHeader)
  };
}

export function* loginFormSaga({ payload }) {
  try {
    const commonData = yield call(getProspectProcessingData);
    const headers = commonData.headers;
    const { deviceId: uniqueId = "" } = headers?.headers?.Authorization
      ? parseJwt(headers.headers.Authorization)
      : "";
    const response = yield call(
      authentication.login,
      { ...payload, deviceId: DEVICE_ID, uniqueId },
      headers
    );
    yield put(loginInfoFormSuccess(response.data));
    yield put(setAccessToken(response.data?.access_token, response.data?.refresh_token));
  } catch (error) {
    log(error);
    yield put(loginInfoFormError(error));
  }
}

export function* logoutSaga({ payload }) {
  try {
    const commonData = yield call(getProspectProcessingData);
    const headers = commonData.headers;
    const agentId = payload.agentId || commonData.agentId;

    const data = {
      username: agentId
    };

    yield call(authentication.logout, data, headers);
    yield put(resetLogin());
    yield put(setAccessToken(""));
    yield put(setPrevDeviceId(""));
    yield put(receiveAppConfig());
  } catch (error) {
    log(error);
  }
}

export default function* loginInfoFormSaga() {
  yield all([takeLatest(LOGIN_INFO_FORM, loginFormSaga)]);
  yield all([takeLatest(LOGOUT, logoutSaga)]);
}
